// @ts-check

import { useMembersDataGridContext } from '~/components/AdminPages/MembersDataGrid/MembersDataGrid.context';
import GridExportButton from '~/components/Shared/DataGrid/GridExportButton';
import { MAX_USER_ROWS } from '~/components/AdminPages/MembersDataGrid/MembersDataGrid.utils';

export default function MembersDataGridExportButton() {
    const { gridRef, setRowCount } = useMembersDataGridContext();

    return (
        <GridExportButton
            gridRef={gridRef}
            setRowCount={setRowCount}
            exportRowCount={MAX_USER_ROWS}
            fileName="ZERO Members Export"
        />
    );
}
